export default __webpack_public_path__ + "static/media/mw18.de8a5891.webp";